import React, { useEffect, useState } from "react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import useT from "../hooks/useT"
import { getYoutubeId } from "../utils/productUtils"

// "Trailer" button opening the YouTube trailer in a modal (client-only)
export default function TrailerButton({ product, className = "" }) {
  const t = useT()
  const [open, setOpen] = useState(false)
  const videoId = getYoutubeId(product?.bookTrailer)

  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === "Escape" && setOpen(false)
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [open])

  if (!videoId) return null
  return (
    <>
      <Button variant="secondary_white" className={`min-w-[150px] ${className}`} onClick={() => setOpen(true)}>
        {t`Trailer`}
      </Button>
      {open && (
        <div className="fixed inset-0 z-[500] bg-black/80 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="relative w-full max-w-[960px]" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute -top-10 right-0 inline-flex items-center gap-1 h-[30px] px-4 rounded-full bg-error text-white text-[14px] font-bold"
            >
              <XMarkIcon className="w-4 h-4" />
              {t`Close`}
            </button>
            <div className="aspect-video w-full bg-black border-2 border-black">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
                title={product.name}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
